import PropagateLoader from "react-spinners/PropagateLoader";

const PreLoader = ({ width }) => {
  return (
    <>
        <span
          className="fixed top-0 bottom-0 left-0 right-0
         z-[9999] flex justify-center items-center backdrop-blur-sm"
        >
          <PropagateLoader color="#fff" size={width ? width : 35} />
        </span>
    </>
  );
};

export default PreLoader;
